import React from 'react';

interface SearchBarProps {
    id: string;
    placeholder: string;
    value: string; // Add value prop to control the input value
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void; // Add onChange prop
    className?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ id, placeholder, value, onChange, className = "" }) => (
    <input
        id={id}
        type="search"
        value={value} // Use the value prop here
        placeholder={placeholder}
    
        onChange={onChange} // Bind onChange prop to handle input changes
        className={`w-1/3 px-3 py-2 border border-gray-300 rounded-lg shadow-sm transition duration-300 ease-in-out hover:border-blue-400 hover:shadow-md focus:outline-none focus:border-secondary focus:border-2 width-full ${className}`}
    />
);

export default SearchBar;
